import React from "react";
import "../pagesstyles/aboutpages.css";
function Teamdrop() {
  return (
    <>
      <div className="pageone">
        <div className="container">
          <div className="banner-content">
            <h1>Our Team </h1>
            <div className="breadcrumb">
              <span><i class="fa-solid fa-house"></i>Home</span>
              <span className="separator">/</span>
              <span className="current">Our Team</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default  Teamdrop;